import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  loggedIn: boolean = false
  isLoggedIn$: Observable<boolean>;
  
  constructor(private router: Router, private loginService:LoginService){
    this.isLoggedIn$ = this.loginService.isLoggedIn;
    this.isLoggedIn$.subscribe(logIn => {
      this.loggedIn = logIn; 
    })
  }

  canActivate(){
    const isLoggedIn = this.loggedIn;
    if (isLoggedIn) {
      return true
    } else {
      this.router.navigate(['login'])
    }
  }
  
}
